import Vue from 'vue';
import Router from 'vue-router';
import DefaultLayout from './views/layouts/DefaultLayout.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/login',
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/auth/Login.vue'),
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./views/auth/Register.vue'),
        },
        {
            path: '/tools/transcription_accuracy',
            name: 'accuracy',
            component: () => import('./views/pages/tools/Accuracy.vue'),
        },
        {
            path: '/tools/translation_analysis',
            name: 'analysis',
            component: () => import('./views/pages/tools/Analysis.vue'),
        },

        {
            path: '/home',
            component: DefaultLayout,
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: () => import('./views/admin/Welcome.vue'),
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () => import('./views/pages/dashboard/Index.vue'),
                },
                {
                    path: '/admin/users',
                    name: 'users',
                    component: () => import('./views/admin/users/Index.vue'),
                },
                {
                    path: '/admin/create-user',
                    name: 'create-user',
                    component: () => import('./views/admin/users/Add.vue'),
                },
                {
                    path: '/admin/edit-user/:username',
                    name: 'edit-user',
                    component: () => import('./views/admin/users/Edit.vue'),
                },
                {
                    path: '/jobs',
                    name: 'jobs',
                    component: () => import('./views/pages/jobs/Index.vue'),
                },
                {
                    path: '/live-jobs',
                    name: 'live-jobs',
                    component: () => import('./views/pages/livejobs/Index.vue'),
                },
                {
                    path: '/translation-jobs',
                    name: 'translation-jobs',
                    component: () => import('./views/pages/translationJobs/Index.vue'),
                },
                {
                    path: '/create-job',
                    name: 'create-job',
                    component: () => import('./views/pages/jobs/Add.vue'),
                },
                {
                    path: '/create-live-job',
                    name: 'create-live-job',
                    component: () => import('./views/pages/livejobs/Add.vue'),
                },
                {
                    path: '/create-translation-job',
                    name: 'create-translation-job',
                    component: () => import('./views/pages/translationJobs/Add.vue'),
                },
                {
                    path: '/view-job/:job_id',
                    name: 'view-job',
                    component: () => import('./views/pages/jobs/View.vue'),
                },
                {
                    path: '/view-subtitles/:job_id',
                    name: 'view-subtitles',
                    component: () => import('./views/pages/jobs/ViewSubtitles.vue'),
                },
                {
                    path: '/view-live-job/:job_id',
                    name: 'view-live-job',
                    component: () => import('./views/pages/livejobs/View.vue'),
                },
                {
                    path: '/live-qc-editor/',
                    name: 'live-qc-editor',
                    component: () => import('./views/pages/livejobs/QcEditor.vue'),
                },
                {
                    path: '/live-player/:jobId',
                    name: 'live-player',
                    component: () => import('./views/pages/livejobs/Player.vue'),
                },
                {
                    path: '/usage',
                    name: 'usage',
                    component: () => import('./views/pages/reports/Index.vue'),
                },
                {
                    path: '/qc-dashboard',
                    name: 'qc-dashboard',
                    component: () => import('./views/pages/jobs/Index.vue'),
                },
                {
                    path: '/profile',
                    name: 'profile',
                    component: () => import('./views/user/Profile.vue'),
                },
                {
                    path: '/change-password',
                    name: 'change-password',
                    component: () => import('./views/user/ChangePassword.vue'),
                },
                {
                    path: '/edit-subtitles/:job_id/:lang_code',
                    name: 'edit-subtitles',
                    component: () => import('./views/pages/jobs/EditSubtitles.vue'),
                },
            ],
        },
        {
            path: '/404',
            name: '404',
            component: () => import('./views/errors/NotFound.vue'),
        },
        {
            path: '*',
            redirect: '/404',
        },
    ],
});

router.beforeEach((to, from, next) => {
    const publicPages = ['/login', '/register', '/404'];
    const authRequired = !publicPages.includes(to.path);

    if (authRequired) {
        if ($cookies.isKey('user')) {
            const user = $cookies.get('user');
            if (user.access_token != (null || undefined)) {
                next();
            } else {
                return next('/login');
            }
        } else {
            return next('/login');
        }
    }
    next();
});
export default router;
